

<div class="input-group">
  <ng-content/>
  <button class="input-group-text border-0" [ngClass]="btnClasses ? btnClasses : defaultClasses" (click)="openQrModal()"
          [style]="{'width': btnPxWidth || '50px'}" type="button">
    <i class="fa-solid fa-camera"></i>
  </button>
</div>


